import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import "./index.scss"

import { Popup, Loading, ConfirmDialog } from "components"
import { message, integrationSheets } from "state_management"
import useT from "utils/hooks/useT"
import Table from "react-bootstrap/Table"
import { IntegrationSheetConfig } from "components/Config"

export default function EditSheets({ isAutomatic = false }) {
  const { t } = useT("messages")
  const { t: tc } = useT("common")
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const showProjects = useSelector((state) => state.teamStatus.showProjects)
  const showAnalyses = useSelector((state) => state.teamStatus.showAnalyses)

  const [activeSheet, setActiveSheet] = useState(null)
  const [delSheet, setDelSheet] = useState(null)

  const [newSheetType, setNewSheetType] = useState("")
  const [newSheetName, setNewSheetName] = useState("")

  const actualNewSheetType = isAutomatic
    ? newSheetType
    : !showProjects
      ? "SampleObservationUploadConfig"
      : newSheetType
        ? newSheetType
        : "ActionUploadConfig";
  const isLoading = useSelector((state) =>
    isAutomatic
      ? state.integrationSheets.isLoadingLimsSheets ||
        state.integrationSheets.isLoadingSapSheets
      : state.integrationSheets.isLoadingActionSheets ||
        state.integrationSheets.isLoadingSampleSheets ||
        state.integrationSheets.isLoadingProjectTemplateSheets
  )

  const actionSheets = useSelector((state) => state.integrationSheets.actionSheets)
  const projectTemplateSheets = useSelector((state) => state.integrationSheets.projectTemplateSheets)
  const sampleSheets = useSelector((state) => state.integrationSheets.sampleSheets)
  const limsSheets = useSelector((state) => state.integrationSheets.limsSheets)
  const sapSheets = useSelector((state) => state.integrationSheets.sapSheets)

  useEffect(() => {
    if (!isAutomatic && (!actionSheets || !sampleSheets || !projectTemplateSheets) && !isLoading) {
      dispatch(integrationSheets.fetchActionSheets())
      dispatch(integrationSheets.fetchSampleSheets())
      dispatch(integrationSheets.fetchProjectTemplateSheets())
    } else if (isAutomatic && !limsSheets && !sapSheets && !isLoading) {
      dispatch(integrationSheets.fetchLimsSheets())
      dispatch(integrationSheets.fetchSapSheets())
    }
  })

  useEffect(() => {
    if (isAutomatic && !showProjects ) {
      setNewSheetType("LimsUploadConfig")
    }
    }, [showProjects, isAutomatic])

  if (!isAutomatic && (!actionSheets || !sampleSheets || !projectTemplateSheets) && !isLoading) {
    return <Loading title={tc("loadingSheets")} />
  }

  if (isAutomatic && !limsSheets && !sapSheets && !isLoading) {
    return <Loading title={tc("loadingSheets")} />
  }

  if (isLoading) {
    return <Loading title={tc("loadingSheets")} />
  }

  const handleSaveConversionSheet = (e) => {
    if (!newSheetName) {
      dispatch(message.error(t("adhoc.provideSheetName")));
    } else if (
      (() => {
        for (var i = 0; i < sheetsToDisplay.length; i++) {
          if (sheetsToDisplay[i].sheetName === newSheetName) {
            return true;
          }
        }
        return false;
      })()
    ) {
      dispatch(message.error(t("adhoc.sheetNameAlreadyExists")));
    } else if (!actualNewSheetType) {
      dispatch(message.error(t("adhoc.provideSheetType")));
    } else {
      setActiveSheet({
        __typename: actualNewSheetType,
        sheetName: newSheetName,
      });
    }
  };

  const sheetsToDisplay = isAutomatic ? limsSheets.concat(sapSheets) : actionSheets.concat(sampleSheets).concat(projectTemplateSheets)

  return (
    <>
      {delSheet && (
        <ConfirmDialog
          onCancel={() => setDelSheet(null)}
          onConfirm={() => {
            if (delSheet.__typename === "ActionUploadConfig") {
              dispatch(integrationSheets.removeActionSheet(delSheet.id)).then(() => setDelSheet(null))
            } else if (delSheet.__typename === "ProjectTemplateUploadConfig") {
              dispatch(integrationSheets.removeProjectTemplateSheet(delSheet.id)).then(() => setDelSheet(null))
            } else if (delSheet.__typename === "SampleObservationUploadConfig") {
              dispatch(integrationSheets.removeSampleSheet(delSheet.id)).then(() => setDelSheet(null))
            } else if (delSheet.__typename === "LimsUploadConfig"){
              dispatch(integrationSheets.removeLimsAnalysisSheet(delSheet.id)).then(() => setDelSheet(null))
            } else {
              dispatch(integrationSheets.removeSapSheet(delSheet.id)).then(() => setDelSheet(null))
            }
          }}
        >
          <h4>{tc("confirmDeletion")}</h4>
        </ConfirmDialog>
      )}

      <Table className="EditSheetsTable" striped bordered>
        <thead>
          <tr>
            <th>{tc("sheetName")}</th>
            <th>{tc("sheetType")}</th>
            <th>{tc("configuration")}</th>
            {isAutomatic && <th>{tc("conversionSheet")}</th>}
          </tr>
        </thead>
        <tbody>
          {sheetsToDisplay?.map((sheet) => (
            <tr key={sheet.sheetName}>
              <td>{sheet.sheetName}</td>
              <td>
                {sheet.__typename === "ActionUploadConfig"
                  ? tc("projectsAndActions")
                  : sheet.__typename === "ProjectTemplateUploadConfig"
                  ? tc("projectTemplate")
                  : sheet.__typename === "LimsUploadConfig"
                  ? tc("sampleImport")
                  : sheet.__typename === "SapUploadConfig"
                  ? tc("projectImport")
                  : tc("sampleObservations")
                  }
              </td>
              <td>
                <button onClick={() => setActiveSheet(sheet)}>{tc("edit")}</button>
                <button
                  onClick={() => setDelSheet(sheet)} //
                  className="EditSheets-delete-button"
                  title={tc("delete")}
                  aria-label={tc("close")}
                >
                  <span aria-hidden="true">{tc("delete")}</span>
                </button>
              </td>
              {isAutomatic && (
                <td>
                  <button variant="warning" onClick={() => navigate(`/setup/integration/conversion-sheet/${sheet.id}`)}>
                    {tc("view")}
                  </button>
                </td>)
              }
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td>
              <input value={newSheetName} onChange={(e) =>
                setNewSheetName(e.target.value)} />
            </td>
            <td>
              {isAutomatic ? (
                !showProjects ? (
                <div>
                    {tc("sampleImport")}
                </div>
                ) : (
                    <select onChange={(e) => setNewSheetType(e.target.value)}>
                      <option value="">{tc("selectType")}</option>
                      <option value="LimsUploadConfig">{tc("sampleImport")}</option>
                      <option value="SapUploadConfig">{tc("projectImport")}</option>
                    </select>
                  )
              ) : showProjects && showAnalyses ? (
                  <select onChange={(e) => setNewSheetType(e.target.value)}>
                    <option value="">{tc("selectType")}</option>
                    <option value="ActionUploadConfig">{tc("projectsAndActions")}</option>
                    <option value="SampleObservationUploadConfig">{tc("sampleObservations")}</option>
                    <option value="ProjectTemplateUploadConfig">{tc("projectTemplate")}</option>
                  </select>
                ) : showProjects ? (
                    <select onChange={(e) => setNewSheetType(e.target.value)}>
                      <option value="ActionUploadConfig">{tc("projectsAndActions")}</option>
                      <option value="ProjectTemplateUploadConfig">{tc("projectTemplate")}</option>
                    </select>
                  ) : (
                      tc("sampleObservations")
                    )}
            </td>
            <td>
              <button
                onClick={(e) => handleSaveConversionSheet(e)}
              >
                {tc("add")}
              </button>
            </td>
          </tr>
        </tfoot>
      </Table>

      {activeSheet !== null && (
        <Popup nonScrollable onCancel={() => setActiveSheet(null)}>
          <IntegrationSheetConfig sheet={activeSheet} onClose={() => setActiveSheet(null)} />
        </Popup>
      )}
    </>
  )
}
